export var AmplifyFlowType;
(function (AmplifyFlowType) {
    AmplifyFlowType["USER_PASSWORD_AUTH"] = "USER_PASSWORD_AUTH";
})(AmplifyFlowType || (AmplifyFlowType = {}));
export var AmplifyResponseType;
(function (AmplifyResponseType) {
    AmplifyResponseType["TOKEN"] = "token";
    AmplifyResponseType["CODE"] = "code";
})(AmplifyResponseType || (AmplifyResponseType = {}));
